import cx from 'clsx';

import { Text } from '@manage-cards/constants';

import { Overlay, Image, Button } from '@shared/components/core';

import phonepeLogo from '@assets/icons/PhonePeLogo.svg';

import styles from './LoginToPhonePeModal.module.scss';

const LoginToPhonePeModal = ({ handleLogin }: { handleLogin: () => void }) => (
	<Overlay isOpen showCloseButton={false} handleMobileResolution={false}>
		<div
			className={cx('p5 bg-white border-radius3', styles.loginModalContainer)}
		>
			<div className="center">
				<Image
					src={phonepeLogo}
					alt="PhonePe"
					height={56}
					width={56}
					className="mt3"
				/>
				<h2 className="h4 bold dark1 mb2 left-align">
					{Text.LOGIN_USING_PHONE_PE_HEADER}
				</h2>
				<p className="h5 lighter dark2 mt2 mb6 left-align">
					{Text.LOGIN_USING_PHONE_PE_DESCRIPTION}
				</p>
			</div>
			<Button className="width100" variant="primary" onClick={handleLogin}>
				{Text.CLICK_TO_LOGIN_WITH_PHONE_PE}
			</Button>
		</div>
	</Overlay>
);

export default LoginToPhonePeModal;
